import { KeyboardEvent } from 'react';
import { KeyCode } from '@app/const';

const arrowKeyCodes = new Set<string>([
  KeyCode.arrowDown,
  KeyCode.arrowLeft,
  KeyCode.arrowRight,
  KeyCode.arrowUp
]);

export function isArrowKey(codeOrEvent: KeyboardEvent | KeyCode) {
  const code = (typeof codeOrEvent === 'string') ? codeOrEvent : (
    codeOrEvent.code as KeyCode
  );
  return arrowKeyCodes.has(code);
}
